export default __webpack_public_path__ + "static/media/calendar.6b2b2958.svg";